module.exports = __webpack_public_path__ + "assets/images/76719d5d990138dfccfc01723244b7f2.png";